import { plainAxiosInstanceAuth } from '../../api/apiMotoBoutique'


export const loginUser = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        plainAxiosInstanceAuth
            .post(`/api/auth/login`, { email: payload.email, password: payload.password })
            .then((response) => {
                if (response.data.message === "Inicio de sesión correcto") {
                    commit("setUserInfo", response);
                    resolve(response);
                }
                else {
                    reject(response.data.message);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export const logoutUser = ({ commit }) => {
    // console.log('CERRANDO SESION')
    return new Promise((resolve, reject) => {
        plainAxiosInstanceAuth
            .get(`/api/auth/logout`)
            .then(async (response) => {
                // console.log(response)
                if (response.data.message === "Sesion cerrada") {
                    await commit("resetUserInfo");
                    resolve(response)
                }
                else{
                    reject(response); 
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export const loginUserWithToken = ({ commit }, payload) => {
    const config = {
        headers: {
            Authorization: `Bearer ${payload.auth_token}`,
        },
    };
    return new Promise((resolve, reject) => {
        plainAxiosInstanceAuth
            .get(`/api/getclients`, config)
            // .get(`/api/getstocks`, config)
            .then((response) => {
                if (response.data.message === "Consulta exitosa") {
                    commit("setUserInfoFromToken", `Bearer ${payload.auth_token}`);
                    resolve(true);
                }
                else {
                    console.log("ERROR 1 ", payload.auth_token)
                    commit("resetUserInfo")
                    reject(false);
                }
            })
            .catch((err) => {
                console.log("ERROR 2 ", err)
                commit("resetUserInfo")
                reject(false);
            });
    });
}

export const notAuthenticated = ({ commit }) => {
    commit("resetUserInfo");
}